import { mergeArrayObjects } from '../utils/mergeArrayObjects'

export const withHeaderOptions =
  component =>
  (...options) => {
    component.headerOptions = mergeArrayObjects(options)

    return component
  }
